// HomePage.js
import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import c3v60Logo from '../assets/images/c3v60_logo.jpg'; // Adjusted path
import flexiblePlatform from '../assets/images/flexiblePlatformSide.webp'; // Adjusted path
import boxesWithModules from '../assets/images/boxesWithModules.webp'; // Adjusted path
import securityLock from '../assets/images/securityLock.webp'; // Adjusted path
import integrationWithOtherSystems from '../assets/images/integrationOtherSystems.webp'; // Adjusted path
import '../css/HomePage.css'; // Import the CSS file

const HomePage = () => {
  const { t } = useTranslation();
  const rightMadeInCanadaImageFile = t('homePage.rightMadeInCanadaImage');
  const leftMadeInCanadaImageFile = t('homePage.leftMadeInCanadaImage');

  // Dynamically require the image so Webpack can process it
  let rightMadeInCanadaImage;
  try {
    rightMadeInCanadaImage = require(`../assets/images/${rightMadeInCanadaImageFile}`);
  } catch (error) {
    console.error("Image not found:", error);
  }
  let leftMadeInCanadaImage;
  try {
    leftMadeInCanadaImage = require(`../assets/images/${leftMadeInCanadaImageFile}`);
  } catch (error) {
    console.error("Image not found:", error);
  }
  const content = [
    {
      id: 1,
      image: flexiblePlatform,
      title: t('homePage.content2Title'),
      text: t('homePage.content2'),
      detailsLink: '/details#section1', // Add hash
    },
    {
      id: 2,
      image: boxesWithModules,
      title: t('homePage.content3Title'),
      text: t('homePage.content3'),
      detailsLink: '/details#section2', // Add hash
    },
    {
      id: 3,
      image: securityLock,
      title: t('homePage.content4Title'),
      text: t('homePage.content4'),
      detailsLink: '/details#section3', // Add hash
    },
    {
      id: 4,
      image: integrationWithOtherSystems,
      title: t('homePage.content5Title'),
      text: t('homePage.content5'),
      detailsLink: '/details#section4', // Add hash
    },
  ];
  
  return (
    <div>
      {/* Top Text Section */}
      <div className="text-center">
        <h1>{t('homePage.legend')}</h1>
        <h3>{t('homePage.empower')}</h3>
        <div
          className="d-flex flex-column flex-md-row align-items-center justify-content-center"
          style={{ gap: '10px' }} // Add some spacing between items
        >
          {/* Left image */}
          <img
            src={leftMadeInCanadaImage}
            alt="Made in Canada Left"
            className="responsive-image left-image"
          />
          
          {/* c3v60 logo */}
          <img
            src={c3v60Logo}
            alt="c3v60"
            className="responsive-logo"
          />
  
          {/* Right image */}
          <img
            src={rightMadeInCanadaImage}
            alt="Made in Canada Right"
            className="responsive-image right-image"
          />
        </div>
        <h4>{t('homePage.ultimate')}</h4>
        <h5>{t('homePage.content1')}</h5>
      </div>
  
      {/* Grid Section */}
      <div className="row justify-content-center">
        {content.map((item) => (
          <div key={item.id} className="col-md-4 mb-4">
            <ExpandableBox item={item} />
          </div>
        ))}
      </div>
  
      {/* Bottom Text Section */}
      <div className="text-center">
        <h3>{t('homePage.joinRevolution')}</h3>
        {/* Button placed outside of collapsible section to ensure visibility */}
        <Link
          to="/register"
          className="btn btn-primary ms-3 mb-4"
          style={{ backgroundColor: '#1520bf', borderColor: '#1520bf' }}
        >
          {t('layout.buttons.requestDemo')}
        </Link>
      </div>
    </div>
  );  
};

const ExpandableBox = ({ item }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { t } = useTranslation();

  const handleToggleExpand = (e) => {
    e.stopPropagation(); // Prevent the click from triggering the navigation
    setIsExpanded(!isExpanded);
  };

  const displayedText = isExpanded ? item.text : `${item.text.slice(0, 200)}...`;

  return (
    <div className="card h-100 expandable-box">
      <img src={item.image} className="card-img-top fixed-image" alt="..." />
      <div className="card-body">
        <p className="card-title">{item.title}</p>
        <p className="card-text">{displayedText}</p>
        <button onClick={handleToggleExpand} className="btn btn-link">
          {isExpanded ? t('homePage.showLess') : t('homePage.showMore')}
        </button>
        {/* Remove the stretched-link class */}
        <Link to={item.detailsLink} className="btn btn-primary mt-2">
          {t('homePage.buttons.buttonText')}
        </Link>
      </div>
    </div>
  );
};

export default HomePage;
